import axios from "../Config/index";

const ServicePhoneRoute = {
  SipUsers: (param) =>
    axios.get("/service-phone/phone/sip-users", { params: param }),
};
export default ServicePhoneRoute;
